// ----------------------------------------------------------------------------
// Initialize Modernizr
// ----------------------------------------------------------------------------
//
// Scripts to support Accessibility
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Load Modernizr Configuration
// -------------------------------------

import '../../../../.modernizrrc';


// -------------------------------------
// Extend Modernizr
// -------------------------------------

document.addEventListener("DOMContentLoaded", function(event) {

    // Detect IE11
    // Source: https://gist.github.com/oobleck/8428063
    // Author: oobleck + contribution from SDShooter
    Modernizr.addTest('ie11', function() {
        // https://en.wikipedia.org/wiki/Internet_Explorer_11
        'use strict';
        // var ua = navigator.userAgent;
        // var match = /Trident.*rv[\s:]11\./i.test(ua);
        // ('msTransform' in document.body.style)
        var match = (!!document.documentMode &&
            !document.all &&
            (!!window.matchMedia || !!window.msMatchMedia) &&
            !Modernizr.websqldatabase &&
            !Modernizr.cssreflections
        );
        return match && (window.navigator.userAgent.indexOf('Edge/') == -1)
    });
});


// -------------------------------------
// Detect Cookie Support and add a Class
// -------------------------------------

// function cookiesEnabled() {
//     var cookieEnabled = navigator.cookieEnabled;

//     if (!cookieEnabled) {
//         document.cookie = 'testcookie';
//         cookieEnabled   = document.cookie.indexOf('testcookie') !== -1;
//     }
//     return cookieEnabled;
// }

// if (cookiesEnabled()) {
//     document.documentElement.className = document.documentElement.className.replace(
//         'supports-no-cookies',
//         'supports-cookies',
//     );
// }
